


































































































































































































































































































































































import { Prop, Emit, Watch, Component, Mixins } from 'vue-property-decorator';
import colors from 'vuetify/es5/util/colors';
import { inject } from 'inversify-props';
import ClientModel from '@/models/crm/client.model';
import { ClientStatusEnum } from '@/enums/crm/client-status.enum';
import { StringHelper } from '@/utils/helpers/string-helper';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import { OrigemTypeEnum } from '@/enums/origin-register-type.enum';
import SettingsModel from '@/models/crm/settings.model';
import ResponsibleAttendantModel from '@/models/crm/responsible-attendant.model';
import RouterService from '@/services/router.service';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import SessionService from '@/services/session.service';
import ClientManagementModel from '@/models/crm/client-management.model';
import { ClientManagerSituationEnum } from '@/enums/crm/client-manager-situation-enum';
import ClientService from '@/services/crm/client.service';
import ClientManagementService from '@/services/crm/client-management.service';
import EvoTalksMixin from '@/mixins/crm/evotalks.mixin';
import EvoTalksSyncingDialog from '@/components/crm/evotalks-syncing-dialog.vue';

interface IChipParam {
  id: string;
  text?: string;
  htmlContent?: string;
  icon: string;
  color: string;
}

@Component({
  components: {
    EvoTalksSyncingDialog,
  },
})
export default class GeoChatClientDetailsCard extends Mixins(EvoTalksMixin) {
  @inject(InjectionIdEnum.RouterService)
  private routerService!: RouterService;

  @inject(InjectionIdEnum.SessionService)
  private sessionService!: SessionService;

  @inject(InjectionIdEnum.CrmClientService)
  private clientService!: ClientService;

  @inject('CrmClientManagementService') private clientManagementService!: ClientManagementService;

  client: ClientModel | null = null;

  @Prop({ type: String, required: false }) clientId!: string | null;

  @Prop({ required: true })
  readonly clientType!: ClientTypeEnum;

  @Prop({ required: true })
  readonly origemType!: OrigemTypeEnum;

  @Prop()
  readonly settings!: SettingsModel;

  @Prop()
  readonly actionsLoading!: boolean;

  allClientManagements!: ClientManagementModel[];

  attendantsList!: ResponsibleAttendantModel[];

  @Prop()
  readonly clientNotIntegrated?: boolean;

  @Prop({ default: false })
  readonly disabled!: boolean;

  managementExpansionPanel: number[] = [];

  emailAddressee!: string;

  loadingData = false;

  @Watch('clientId')
  @Watch('clientType')
  async onClientChanged(): Promise<void> {
    if (this.clientId) {
      await this.loadClient(this.clientId);
    } else {
      this.client = null;
      this.resetCRMEvoTalksStatus();
    }
  }

  async loadClient(id: string): Promise<void> {
    this.loadingData = true;
    try {
      this.client = await this.clientService.get(id, this.clientType);
      await this.loadCRMEvoTalksStatus();
    } catch (error) {
      this.client = null;
      this.resetCRMEvoTalksStatus();
    } finally {
      this.loadingData = false;
    }
  }

  mounted(): void {
    if (this.clientId) {
      this.loadClient(this.clientId);
    }
  }

  @Emit('send-email:click')
  onSendEmail(email: string): string {
    this.emailAddressee = email;
    return this.emailAddressee;
  }

  @Emit('open-particularities')
  onOpenParticularities(): ClientModel | null {
    return this.client;
  }

  @Emit('set-responsible')
  onSetResponsibleAttendant(responsibleAttendant: number): number | null {
    (this.$refs.responsibleAttendantSelect as HTMLElement)?.blur();
    return responsibleAttendant;
  }

  @Emit('integrate-client')
  onIntegrateClient(): ClientModel | null {
    return this.client;
  }

  get isClientType(): boolean {
    return this.clientType === ClientTypeEnum.Client;
  }

  get isProspectType(): boolean {
    return this.clientType === ClientTypeEnum.Prospect;
  }

  get showActionsMenu(): boolean {
    return this.showEvoTalksActions;
  }

  get isOrigemNaoDefinida(): boolean {
    return (this.client?.origemCadastro === OrigemTypeEnum.SEMORIGEM || this.origemType === null);
  }

  get isOrigemCrm(): boolean {
    return this.client?.origemCadastro === OrigemTypeEnum.CRM;
  }

  get isOrigemB2B(): boolean {
    return this.client?.origemCadastro === OrigemTypeEnum.B2B;
  }

  get isOrigemForcaVendas(): boolean {
    return this.client?.origemCadastro === OrigemTypeEnum.FORCAVENDAS;
  }

  get isOrigemForcaVendasTextil(): boolean {
    return this.client?.origemCadastro === OrigemTypeEnum.FORCAVENDASTEXTIL;
  }

  get isOrigemLandingPageAlphabeto(): boolean {
    return this.client?.origemCadastro === OrigemTypeEnum.LANDINGPAGEALPHABETO;
  }

  get isOrigemRDStation(): boolean {
    return this.client?.origemCadastro === OrigemTypeEnum.RDSTATION;
  }

  get isOrigemCRMIntegracao(): boolean {
    return this.client?.origemCadastro === OrigemTypeEnum.CRMINTEGRACAO;
  }

  get showTransformProspectBtn(): boolean {
    return this.isProspectType && this.settings?.flagConverteProspectIGS && !this.isConvertedProspect;
  }

  get isProspectOrClientIsIntegrated(): boolean {
    if (this.clientType === ClientTypeEnum.Prospect) return true;
    if (this.clientType === ClientTypeEnum.Client && !this.clientNotIntegrated) return true;
    return false;
  }

  get showIntegrateClient(): boolean {
    return !this.isProspectOrClientIsIntegrated && this.settings?.flagIntegracaoClienteUnicoAtivo === true;
  }

  private allAvailableChipsCache: IChipParam[] | null = null;

  private allAvailableChipsCacheKey = '';

  get allAvailableChips(): IChipParam[] {
    if (!this.client || !this.client.cnpjCpf) {
      return [];
    }

    const managementsCount = this.allClientManagements?.length || 0;
    const cacheKey = [
      this.client.cnpjCpf,
      this.client.inadimplente,
      this.client.limiteCredito,
      managementsCount,
      this.client.codGrupoEconomico,
    ].join('-');
    if (this.allAvailableChipsCache && this.allAvailableChipsCacheKey === cacheKey) {
      return this.allAvailableChipsCache;
    }

    const availableChips: IChipParam[] = [];

    if (this.client.inadimplente) {
      availableChips.push({
        id: 'defaulting',
        text: `${this.$t('crm.clientDetailsCard.defaulting')} - ${this.client.diasInadimplente}`,
        icon: 'mdi-thumb-down-outline',
        color: 'red',
      });
    }

    if (this.allClientManagements && Array.isArray(this.allClientManagements)) {
      const limiteGestoes = this.settings?.quantidadeGestoesPainelRelacionamento ?? 4;
      const recentManagements = this.allClientManagements.slice(0, limiteGestoes);

      recentManagements.forEach((management, index) => {
        let chipText = management.managementName || '';
        if (management.situation) {
          chipText += chipText ? ` (${management.situation})` : management.situation;
        }

        if (chipText) {
          const nomeGestao = management.managementName || 'N/A';
          const situacaoGestao = management.managerSituation || 'N/A';
          const classificacao = management.situation || 'N/A';
          const valorGasto = `R$ ${management.value.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}` || 'N/A';
          const quantidadeCobrada = management.quantity;

          const valorColor = management.managerSituation === ClientManagerSituationEnum.Ativo
            ? '#4caf50'
            : '#f44336';

          const chipHtmlContent = `
            <div style="text-align: left; font-size: 12px;">
                <div style="margin-bottom: 4px;">Classificação:
                  <span style="font-weight: 500;">${classificacao}</span>
                </div>
                <div style="margin-bottom: 4px;">Valor Gasto:
                  <span style="font-weight: 500; color: ${valorColor};">${valorGasto}</span>
                </div>
                <div>Qtd. Comprada: <span style="font-weight: 500;">${quantidadeCobrada}</span></div>
            </div>`;

          const chipColor = management.managerSituation === ClientManagerSituationEnum.Ativo ? 'green' : 'red';

          if (nomeGestao !== 'N/A' || situacaoGestao !== 'N/A') {
            availableChips.push({
              id: `mng-${management.collectionId || index}`,
              text: chipText,
              htmlContent: chipHtmlContent,
              icon: 'mdi-briefcase-check-outline',
              color: chipColor,
            });
          }
        }
      });
    }
    if (this.client.limiteCredito || this.client.limiteCredito === 0) {
      availableChips.push({
        id: 'creditLimit',
        text: `${this.$t('crm.view.financialInformation.card.creditLimit')} -
              ${this.$n(this.client.limiteCredito, 'currency')}`,
        icon: 'mdi-currency-usd',
        color: this.client.limiteCredito < 0 ? 'red' : 'green',
      });
    }

    if (this.client.codGrupoEconomico && this.client.nomeGrupoEconomico) {
      availableChips.push({
        id: `${this.client.codGrupoEconomico}`,
        text: `Nome do Grupo - ${this.client.nomeGrupoEconomico}`,
        icon: 'mdi-account-group',
        color: 'green',
      });
    }

    this.allAvailableChipsCache = availableChips;
    this.allAvailableChipsCacheKey = cacheKey;
    return availableChips;
  }

  get managementChips(): IChipParam[] {
    return this.allAvailableChips.filter((chip) => chip.id.startsWith('mng-'));
  }

  get activeManagementChips(): IChipParam[] {
    return this.managementChips.filter((chip) => chip.color === 'green');
  }

  get inactiveManagementChips(): IChipParam[] {
    return this.managementChips.filter((chip) => chip.color === 'red');
  }

  get otherChips(): IChipParam[] {
    return this.allAvailableChips.filter((chip) => !chip.id.startsWith('mng-'));
  }

  getManagementName(chip: IChipParam): string {
    const managementId = chip.id.replace('mng-', '');

    if (this.allClientManagements && Array.isArray(this.allClientManagements)) {
      const management = this.allClientManagements.find(
        (item, index) => item.collectionId?.toString() === managementId || index.toString() === managementId,
      );

      if (management && management.managementName) {
        return management.managementName;
      }
    }

    return chip.text || '';
  }

  get nameInitials(): string {
    if (!this.client) return '';
    return StringHelper.extractInitialsName(this.client.nomeFantasia || this.client?.nome).toUpperCase();
  }

  get statusColor(): string {
    switch (this.client?.situacao) {
      case ClientStatusEnum.Inactive:
      case ClientStatusEnum.ConversionFailed:
        return colors.red.base;
      case ClientStatusEnum.Converted:
        return '#00dbc6';
      case ClientStatusEnum.Blocked:
        return '#f47304';
      case ClientStatusEnum.Active:
      default:
        return colors.green.base;
    }
  }

  get cnpjCpfMask(): string {
    if (!this.client?.cnpjCpf) return '';
    return this.client.cnpjCpf.length > 11 ? 'NN.NNN.NNN/NNNN-NN' : '###.###.###-##';
  }

  get showRedirectButton(): boolean {
    return (this.client?.flagCliente === 1 || this.isConvertedProspect)
      && this.client?.prospectCodCliente != null;
  }

  get isConvertedProspect(): boolean {
    return this.client?.situacao === ClientStatusEnum.Converted;
  }

  get isAddressEmpty(): boolean {
    return !this.client?.cidade
           && !this.client?.endBairro
           && !this.client?.endRua
           && !this.client?.endNumero
           && !this.client?.endComplemento
           && !this.client?.endCEP;
  }

  redirectToClientPage(): void {
    if (!this.client) return;
    this.sessionService.clientType = ClientTypeEnum.Client;
    this.sessionService.activeClient = this.client;
    this.sessionService.activeClient.type = ClientTypeEnum.Client;
    this.routerService.navigate({
      name: 'CrmDashboard',
      params: {
        clientId: this.client.cnpjCpf,
      },
      query: { clientType: ClientTypeEnum.Client },
    });
  }
}
